export const defaultMaxWidthValues = {
  values: {
    SM: "50",
    MD: "33",
    XL: "25",
  },
  measure: "%",
};
